import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import CompanyProfile from '@/pages/companyProfile'
import ProductPresentation from '@/pages/productPresentation'
import Services from '@/pages/services'
import Contact from '@/pages/contact'
import AfterSales from '@/pages/afterSales'
import ProductHome from '@/components/product/ProductHome'
import ProductPage1 from '@/components/product/ProductPage1'
import ProductPage2 from '@/components/product/ProductPage2'
import ProductPage3 from '@/components/product/ProductPage3'
import ProductPage4 from '@/components/product/ProductPage4'
import ProductPage5 from '@/components/product/ProductPage5'
import ProductPage6 from '@/components/product/ProductPage6'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/companyProfile',
      name: 'CompanyProfile',
      component: CompanyProfile
    },
    {
      path: '/productPresentation',
      name: 'ProductPresentation',
      component: ProductPresentation,
      children: [{
        path: '/',
        name:'ProductHome',
        component:ProductHome
      },
      {
        path: 'p1',
        component:ProductPage1
      },
      {
        path: 'p2',
        component:ProductPage2
      },
      {
        path: 'p3',
        component:ProductPage3
      },
      {
        path: 'p4',
        component:ProductPage4
      },
      {
        path: 'p5',
        component:ProductPage5
      },
      {
        path: 'p6',
        component:ProductPage6
      }]
    },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/afterSales',
      name: 'AfterSales',
      component: AfterSales
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js